import dayjs from 'dayjs';
import { Button } from 'primereact/button';
import classNames from 'classnames';
import { Tooltip } from 'primereact/tooltip';

import { ColumnDescription } from '@/components/common/ui/table/ColumnDescription';
import { Pagination } from '@/types/pagination';
import { IconEyesCircle } from '@/components/icons';

export const UserColumns = (
  t: any,
  onShowUserDetail?: (id: number) => void,
  pagination?: Pagination,
): ColumnDescription[] => [
  {
    dataField: 'index',
    text: t('user_management_list.no'),
    headerClassname: 'text-center min-w-[80px]',
    classname: 'min-w-[80px] text-gray-700 text-center',
    formatter: (rowData, index) => {
      const pageOffset = ((pagination?.paginate ?? 1) - 1) * 10;
      return index.rowIndex + pageOffset + 1;
    },
  },
  {
    dataField: 'user_name',
    text: t('user_management_list.user_name'),
    headerClassname: 'min-w-[233px]',
    classname: 'min-w-[233px]',
    formatter: (rowData) => {
      return (
        <>
          <Tooltip target={`.tooltip-point-${rowData.id}-name`}>
            {rowData.full_name_kanji}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-700 break-all',
              `tooltip-point-${rowData.id}-name`,
            )}
            data-pr-position="top"
          >
            {rowData.full_name_kanji}
          </div>
        </>
      );
    },
  },
  {
    dataField: 'email',
    text: t('user_management_list.email'),
    headerClassname: 'min-w-[280px]',
    classname: 'min-w-[280px]',
    formatter: (rowData) => {
      return (
        <>
          <Tooltip target={`.tooltip-point-${rowData.id}-email`}>
            {rowData.email}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-700 break-all',
              `tooltip-point-${rowData.id}-email`,
            )}
            data-pr-position="top"
          >
            {rowData.email}
          </div>
        </>
      );
    },
  },
  {
    dataField: 'graduation_terms',
    sort: true,
    text: t('user_management_list.graduation'),
    headerClassname: 'min-w-[180px] text-center',
    classname: 'min-w-[180px] text-center',
    formatter: (rowData) => {
      return (
        <div>{rowData.graduation.period_number}</div>
      );
    },
  },
  {
    dataField: 'plan',
    text: t('user_management_list.plan'),
    headerClassname: 'min-w-[233px]',
    classname: 'min-w-[233px]',
    formatter: (rowData) => {
      return (
        <div>{rowData.plan.name}</div>
      );
    },
  },
  {
    dataField: 'graduation_term',
    text: t('user_management_list.course'),
    headerClassname: 'min-w-[180px]',
    classname: 'min-w-[180px]',
    formatter: (rowData) => {
      return (
        <div>{rowData.graduation_term?.name ?? '-'}</div>
      );
    },
  },
  {
    dataField: 'created_at',
    text: t('user_management_list.created_date'),
    headerClassname: 'w-[233px] text-center',
    classname: 'w-[233px] text-gray-700 text-center',
    sort: true,
    formatter: (rowData) => (
      <div>
        {rowData.created_at
          ? dayjs(rowData.created_at.toString()).format('YYYY/MM/DD')
          : '-'}
      </div>
    ),
  },
  {
    dataField: 'action',
    text: '',
    sort: false,
    classname: 'min-w-[132px] text-center [&>div]:justify-center',
    headerClassname: 'min-w-[132px] [&>div]:justify-center',
    formatter: (rowData) => (
      <div className="flex flex-row h-[36px] items-center gap-8">
        <Button
          className="p-[5px] text-[#2E90FA]"
          onClick={() => onShowUserDetail?.(rowData.id)}
        >
          <IconEyesCircle />
        </Button>
      </div>
    ),
  },
];
